export default __webpack_public_path__ + "static/media/logo-w.7c599671.svg";